module.exports = __webpack_public_path__ + "static/media/doclad4.9a177ade.pdf";